export default { 
 common: { 
 unit: 'USDT', 
 day: 'ημέρα', 
 week: 'εβδομάδα', 
 save: 'αποθήκευση', 
 submit: 'υποβολή', 
 confirmtitle: 'βεβαιώστε την εκτέλεση της ενέργειας', 
 confirm: 'βεβαιώστε', 
 reset: 'επαναφορά', 
 refresh: 'ανανέωση', 
 copy: 'αντιγραφή', 
 copysuccessful: 'αντιγραφή επιτυχής', 
 modify: 'τροποποίηση', 
 binding: 'δέσμευση', 
 finished: 'ολοκληρώθηκε', 
 canceled: 'ακυρώθηκε', 
 cancel: 'ακύρωση', 
 all: 'όλα', 
 back: 'επιστροφή', 
 loading: 'φόρτωση...', 
 nomore: 'όλα τα ρεκόρδα', 
 errortxt: 'αποτυχία φόρτωσης', 
 loosing: 'αφήστε για ανανέωση...', 
 pulling: 'τραβήξτε για ανανέωση...', 
 nodata: 'δεν υπάρχουν ακόμα εγγραφές', 
 buy: 'αγορά', 
 buyup: 'αγορά αύξησης', 
 buydown: 'αγορά μείωσης', 
 sell: 'πώληση', 
 forserver: 'επικοινωνήστε με την υποστήριξη πελατών', 
 total: 'συνολικά', 
 status1: 'εξέταση σε εξέλιξη ', 
 status2: 'ολοκληρώθηκε ', 
 status3: 'δεν εγκρίθηκε', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'τηλεγραφική μεταφορά', 
 }, 
 footer: { 
 home: 'αρχική σελίδα', 
 market: 'αγορά', 
 exchange: 'ανταλλαγές κρυπτονομισμάτων', 
 options: 'οψιόν', 
 assets: 'περιουσιακά στοιχεία', 
 change: 'μεταφορά', 
 recharge: 'επανεφόρτωση', 
 withdrawal: 'ανάληψη' 
 }, 
 home: { 
 menu1: 'συναλλαγές οψιόν', 
 menu1desc: 'υποστήριξη BTC/USDT κ.λπ.', 
 menu2: 'γρήγορη επανεφόρτωση', 
 menu3: 'ανάληψη', 
 menu4: 'επικοινωνία με τον εξυπηρετητή', 
 menu5: 'άμεση ανταλλαγή', 
 menu6: 'δάνειο υποστήριξης', 
 menu7: 'εξόρυξη με κλείδωμα', 
 menu8: 'ανάθεση', 
 menu9: 'μεταφορά λογαριασμού', 
 ranktitle: 'πίνακας αύξησης', 
 name: 'όνομα', 
 price: 'τελευταία τιμή', 
 risefall: 'αύξηση/μείωση', 
 }, 
 register: { 
 register: 'εγγραφή', 
 login: 'σύνδεση', 
 email: 'Email', 
 phone: 'τηλέφωνο', 
 accountplaceholder: 'πληκτρολογήστε τον λογαριασμό σας', 
 emailplaceholder: 'πληκτρολογήστε το ηλεκτρονικό ταχυδρομείο σας', 
 phoneplaceholder: 'πληκτρολογήστε το τηλέφωνο σας', 
 pwdplaceholder: 'πληκτρολογήστε τον κωδικό πρόσβασης', 
 pwdplaceholder1: 'ο κωδικός πρόσβασης αποτελείται από 6-20 αριθμούς και γράμματα', 
 agepwdplaceholder: 'πληκτρολογήστε ξανά τον κωδικό πρόσβασης', 
 agepwdplaceholder1: 'οι δύο κωδικοί πρόσβασης δεν είναι ίδιοι', 
 invitecodeplaceholder: 'πληκτρολογήστε τον κωδικό πρόσκλησης', 
 remember: 'θυμάμαι τον κωδικό πρόσβασης', 
 forgot: 'έχω ξεχάσει τον κωδικό πρόσβασης' 
 }, 
 market: { 
 title: 'αγορά', 
 all: 'όλα' 
 }, 
 member: { 
 reputation: 'κύρος', 
 identity_authentication: 'πιστοποίηση ταυτότητας', 
 under_review: 'σε εξέταση', 
 certified: 'πιστοποιημένο', 
 awaiting_certification: 'περιμένει πιστοποίηση', 
 binding_withdrawal_address: 'δέσμευση διεύθυνσης ανάληψης', 
 currently_selected_currency: 'επιλεγμένο νόμισμα', 
 withdrawal_address: 'διεύθυνση ανάληψης', 
 sharing_link: 'δικός μου σύνδεσμος μοιράσματος', 
 my_promotion_code: 'δικός μου κωδικός προώθησης', 
 promotion_code: 'κωδικός προώθησης', 
 system_message: 'σύστημα μηνυμάτων', 
 night_mode: 'νυχτερινή λειτουργία', 
 security_center: 'κέντρο ασφαλείας', 
 seted: 'έχει οριστεί', 
 noset: 'δεν έχει οριστεί', 
 login_password: 'κωδικός σύνδεσης', 
 transaction_password: 'κωδικός ανάληψης', 
 app_download: 'κατέβασμα εφαρμογής', 
 log_out: 'αποσύνδεση', 
 aboutus: 'περιγραφή ιστότοπου' 
 }, 
 identity: { 
 title: 'πιστοποίηση ταυτότητας', 
 name: 'όνομα', 
 nameplaceholder: 'πληκτρολογήστε το πραγματικό όνομα σας', 
 uploader: 'ανεβάστε φωτογραφία της ταυτότητας', 
 tip1: 'ανεβάστε την εμπρόσθια όψη της ταυτότητας', 
 tip2: 'ανεβάστε την πίσω όψη της ταυτότητας' 
 }, 
 address: { 
 title: 'δέσμευση διεύθυνσης ανάληψης', 
 bType: 'επιλεγμένο νόμισμα', 
 address: 'διεύθυνση ανάληψης', 
 addressplaceholder: 'πληκτρολογήστε τη διεύθυνση ανάληψης', 
 }, 
 security: { 
 title: 'κέντρο ασφαλείας', 
 modifypwd: 'κωδικός σύνδεσης', 
 resetlegalpwd: 'κωδικός συναλλαγής', 
 loginpwd: 'νέος κωδικός σύνδεσης', 
 pwdage: 'επιβεβαίωση κωδικού', 
 loginpwdplaceholder: 'πληκτρολογήστε τον τρέχοντα κωδικό σύνδεσης', 
 loginnewpwdplaceholder: 'πληκτρολογήστε τον νέο κωδικό σύνδεσης', 
 moneypwd: 'πληκτρολογήστε τον κωδικό συναλλαγής', 
 pwdageplaceholder: 'πληκτρολογήστε ξανά τον κωδικό', 
 }, 
 trade: { 
 title: 'ανταλλαγές κρυπτονομισμάτων', 
 price: 'τιμή', 
 num: 'ποσότητα', 
 entrust: 'τρέχουσες εντολές', 
 clinch: 'πραγματικές συναλλαγές', 
 used: 'διαθέσιμο', 
 buyed: 'διαθέσιμο για αγορά', 
 amount: 'ποσό συναλλαγής', 
 limitprice: 'οριζόμενη τιμή', 
 marketprice: 'τιμή αγοράς', 
 forprice: 'με την τρέχουσα βέλτιστη τιμή συναλλαγής', 
 errorMoney: 'έλλειψη διαθέσιμου υπολοίπου', 
 priceerror: 'πληκτρολογήστε την τιμή εντολής', 
 numerror: 'πληκτρολογήστε την ποσότητα εντολής', 
 moneyerror: 'πληκτρολογήστε το ποσό εντολής', 
 }, 
 assets: { 
 allconvert: 'συνολική αξία περιουσιακών στοιχείων', 
 usenum: 'διαθέσιμο', 
 freeze: 'παγωμένο', 
 convert: 'ισοδύναμο', 
 tab1: 'περιουσιακά στοιχεία', 
 tab11: 'συνολική αξία περιουσιακών στοιχείων', 
 tab12: 'ισοδύναμο οψιόν', 
 tab13: 'ισοδύναμο κεφαλαίου', 
 tab14: 'ισοδύναμο ποσοτικοποίησης', 
 tab2: 'οπσιόν', 
 tab21: 'λογαριασμός οψιόν', 
 tab3: 'κεφάλαιο', 
 tab31: 'λογαριασμός κεφαλαίου', 
 tab4: 'ποσοτικοποίηση', 
 tab41: 'λογαριασμός ποσοτικοποίησης', 
 tbhead1: 'χρηματοοικονομικά αρχεία', 
 tbhead2: 'αρχεία ανάληψης', 
 tbhead3: 'αρχεία επανεφόρτωσης', 
 tbhead4: 'αρχεία μεταφοράς', 
 rcdnum: 'αριθμός', 
 rcd: 'αρχείο', 
 rcdtime: 'ώρα', 
 rcdstatus: 'κατάσταση', 
 rcddesc: 'σχόλιο', 
 rcdaddress: 'διεύθυνση επανεφόρτωσης' 
 }, 
 change: { 
 title: 'μεταφορά', 
 from: 'από {name}', 
 to: 'προς {name}', 
 frmtitle: 'ποσότητα μεταφοράς', 
 inputplaceholder: 'πληκτρολογήστε την ποσότητα μεταφοράς', 
 btntxt: 'μεταφορά' 
 }, 
 recharge: { 
 title: 'επανεφόρτωση', 
 bType: 'τρέχον νόμισμα', 
 address: 'διεύθυνση επανεφόρτωσης', 
 token: 'αποδεικτικό πληρωμής', 
 tokenplaceholder: 'αποστείλετε το αποδεικτικό πληρωμής', 
 num: 'ποσότητα επανεφόρτωσης', 
 numplaceholder: 'πληκτρολογήστε την ποσότητα', 
 btn: 'υποβολή για έγκριση', 
 bankname: 'όνομα τράπεζας', 
 bankno: 'αριθμός τραπεζικού λογαριασμού', 
 accountname: 'όνομα λογαριασμού παραλήπτη', 
 bankaddress: 'διεύθυνση τράπεζας', 
 bankcode: 'κωδικός τραπεζικής εμβάσματος', 
 companyaddress: 'διεύθυνση εταιρείας' 
 }, 
 withdrawal: { 
 title: 'ανάληψη', 
 frmtitle1: 'ποσότητα', 
 frmplaceholder1: 'η ποσότητα ανάληψης πρέπει να είναι μεταξύ {min} - {max}', 
 frmtitle2: 'κωδικός συναλλαγής', 
 frmplaceholder2: 'πληκτρολογήστε τον κωδικό συναλλαγής', 
 getnum: 'ποσότητα που θα εισπραχθεί', 
 fee: 'χρέωση', 
 btn: 'ανάληψη' 
 }, 
 exchangeb: { 
 title: 'ανταλλαγή', 
 account: 'λογαριασμός', 
 btn: 'ανταλλαγή', 
 numerror: 'πληκτρολογήστε την ποσότητα ανταλλαγής' 
 }, 
 option: { 
 title: 'οπσιόν', 
 typetitle: 'συνθήκες δευτερολέπτων', 
 listtitle: 'θέσεις', 
 kline: 'γραμμή K', 
 high: 'υψηλό', 
 low: 'χαμηλό', 
 nums: 'όγκος 24ωρών', 
 time: 'ώρα', 
 transaction: 'τρόπος συναλλαγής', 
 quantity: 'ποσότητα θέσης', 
 quantityerror: 'πληκτρολογήστε την ποσότητα θέσης', 
 times: 'ώρα θέσης', 
 times1: 'Ώρα Διακανονισμού',
 account: 'υπόλοιπο λογαριασμού', 
 buyup: 'αγορά αύξησης', 
 buydown: 'αγορά μείωσης', 
 tab1: 'λίστα θέσεων', 
 tab2: 'αρχεία παραγγελιών', 
 num: 'ποσότητα', 
 price1: 'τιμή αγοράς', 
 price2: 'τιμή συναλλαγής', 
 profitandloss: 'προβλεπόμενη κέρδη/ζημίες', 
 profitandloss1: 'κέρδη/ζημίες', 
 countdown: 'μετρητή αντίστροφης καταγραφής', 
 waitfinish: 'περιμένει διευθέτηση', 
 finishing: 'σε διαδικασία διευθέτησης...', 
 finished: 'διευθετήθηκε', 
 order_price: 'τρέχουσα τιμή', 
 order_cycle: 'κύκλος', 
 order_type: 'τύπος', 
 order_money: 'ποσό', 
 order_time: 'θέση', 
 order_get: 'κέρδος', 
 order_btn: 'συνέχιση παραγγελίας' 
 }, 
 tradelst: { 
 title: 'οι εντολές μου', 
 tab1: 'εντολές', 
 tab2: 'ολοκληρωμένες συναλλαγές', 
 tab3: 'ακυρωμένες', 
 usdtnum: '' 
 }, 
 loans: { 
 title: 'δάνειο υποστήριξης', 
 order_tab: 'παραγγελίες δανείων', 
 pro_tab: 'προϊόντα δανείων', 
 Institution: 'οργανισμός δανεισμού', 
 Amount: 'ποσό', 
 DailyInterest: 'ημερήσια τόκος', 
 RepaymentPeriod: 'διάρκεια αποπληρωμής', 
 Application: 'αίτηση δανείου', 
 orderno: 'αριθμός παραγγελίας', 
 AllInterest: 'συνολικός τόκος', 
 RepaymentDate: 'ημερομηνία αποπληρωμής', 
 RepaymentMethod: 'τρόπος αποπληρωμής', 
 Onetime: 'μία φορά', 
 Expected_loan_amount: 'αποδεκτό ποσό δανείου', 
 Expected_loan_amounterror: 'το ποσό δανείου πρέπει να είναι μεταξύ {min} - {max}', 
 imgplaceholder: 'δάνειο με πιστωτική αξιολόγηση (βεβαιωθείτε ότι η εικόνα είναι καθαρή και ευδιάκριτη)', 
 icon1: 'ανεβάστε την εμπρόσθια όψη του εγγράφου', 
 icon2: 'ανεβάστε την πίσω όψη του εγγράφου', 
 icon3: 'ανεβάστε την εικόνα σας κρατώντας το έγγραφο', 
 status1: 'σε εξέταση', 
 status2: 'έγκριση αιτήματος', 
 status3: 'απορριφθείσα αίτηση', 
 }, 
 lockming: { 
 title: 'εξόρυξη με κλείδωμα', 
 order_tab: 'παραγγελίες μηχανών εξόρυξης', 
 pro_tab: 'αγορά μηχανών εξόρυξης', 
 locknum: 'ελάχιστη ποσότητα κλειδώματος', 
 getforday: 'απόδοση/ημέρα', 
 days: 'ημέρες', 
 estimation: 'προβλεπόμενη απόδοση', 
 real: 'πραγματική απόδοση', 
 balance: 'υπόλοιπο πορτοφολιού', 
 nums: 'ποσότητα κλειδώματος', 
 tolockming: 'κλείδωμα', 
 stime: 'ώρα έναρξης', 
 etime: 'ώρα λήξης', 
 }, 
 transfer: { 
 title: 'μεταφορά λογαριασμού', 
 searchtxt: 'πληκτρολογήστε τον λογαριασμό του παραλήπτη', 
 ReceivingAccount: 'πληροφορίες λογαριασμού παραλήπτη', 
 toaccount: 'λογαριασμός', 
 confirmtxt: 'πατήστε για επιβεβαίωση του λογαριασμού παραλήπτη', 
 confirmedtxt: 'λογαριασμός παραλήπτη επιβεβαιώθηκε', 
 numtxt: 'ποσότητα μεταφοράς', 
 numerror: 'πληκτρολογήστε την ποσότητα μεταφοράς', 
 fee: 'δεν χρεώνεται χρέωση για εσωτερικές μεταφορές', 
 ArrivalTime: 'ώρα παραλαβής', 
 Immediately: 'άμεση παραλαβή', 
 realnum: 'πραγματική ποσότητα που εισπράχθηκε', 
 btn: 'επιβεβαίωση μεταφοράς', 
 transfering: 'σε μεταφορά', 
 orderNo: 'αριθμός παραγγελίας', 
 stime: 'ώρα μεταφοράς', 
 etime: 'ώρα παραλαβής', 
 receiving: 'λογαριασμός παραλήπτη', 
 type: 'νόμισμα', 
 num: 'ποσότητα μεταφοράς', 
 arrivalnum: 'ποσότητα που εισπράχθηκε' 
 }, 
 staking: { 
 title: 'ανάθεση', 
 record: 'αρχείο', 
 getforyear: 'αναφορά ετήσιας απόδοσης', 
 time: 'διάρκεια επένδυσης', 
 snum: 'ελάχιστη ποσότητα επένδυσης', 
 snumerror: 'πληκτρολογήστε την ελάχιστη ποσότητα επένδυσης', 
 snumerror1: 'η ελάχιστη ποσότητα επένδυσης δεν πρέπει να είναι χαμηλότερη από {num}', 
 join: 'μέσω άμεσης συμμετοχής', 
 opentime: 'ώρα έναρξης επένδυσης', 
 money: 'ποσό επένδυσης', 
 days: 'κύκλος', 
 recordget: 'ετήσια απόδοση', 
 gets: 'απόδοση', 
 stime: 'ημέρα έναρξης', 
 etiem: 'ημέρα λήξης', 
 redeemStaking: 'αποσύρση', 
 status0: 'σε περίοδο ανάθεσης', 
 status1: 'τελείωσε η παραγγελία', 
 status2: 'αποσύρθηκε η παραγγελία', 
 }, 
 bank: { 
 title: 'δέσμευση τραπεζικής κάρτας', 
 bankName: 'όνομα τράπεζας', 
 bankNameError: 'πληκτρολογήστε το όνομα της τράπεζας', 
 usrName: 'κάτοχος κάρτας', 
 usrNameError: 'πληκτρολογήστε τον κάτοχο της κάρτας', 
 cardCode: 'αριθμός κάρτας', 
 cardCodeError: 'πληκτρολογήστε τον αριθμό της κάρτας', 
 towallet: 'ανάληψη στο πορτοφόλι', 
 tobank: 'ανάληψη στην τράπεζα', 
 sendcode: 'αποστολή κωδικού ελέγχου', 
 sended: 'αποστολή νέου κωδικού σε {num} δευτερόλεπτα', 
 verify_code: 'πληκτρολογήστε τον κωδικό ελέγχου ηλεκτρονικού ταχυδρομείου' 
 } 
}
